/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-label-repeater',
  template: `
    <ng-container *ngFor="let label of labelArray">
      <a class="resourceLabel label label-primary" *ngIf="!isReadOnly" (click)="search(label)">{{label}}</a>
      <span class="resourceLabel label label-primary" *ngIf="isReadOnly">{{label}}</span>
    </ng-container>
  `
})
export class LabelRepeaterComponent {
  @Input() labels: string[] = [];
  @Input() readOnly: any;

  constructor(private readonly $state: StateService) {}

  get labelArray(): string[] {
    return this.labels || [];
  }

  get isReadOnly(): boolean {
    return this.readOnly === true || this.readOnly === 'true';
  }

  search(label: string): void {
    this.$state.go('app.search', {labels: label});
  }
}
